<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
  computed: {
    contactName() {
      if (!this.contact.fullName) {
        return `${this.contact.firstName} ${this.contact.lastName}`;
      }

      return this.contact.fullName;
    },
    hasAddress1() {
      return Boolean(this.contact.address1);
    },
    hasAddress2() {
      return Boolean(this.contact.address2);
    },
  },
};
</script>
<template>
  <div>
    <h6 class="gl-text-gray-900">{{ title }}</h6>
    <div data-testid="billing-account-contact-full-name">{{ contactName }}</div>
    <div data-testid="billing-account-contact-work-email">{{ contact.workEmail }}</div>
    <div v-if="hasAddress1" data-testid="billing-account-contact-address1">
      {{ contact.address1 }}
    </div>
    <div v-if="hasAddress2" data-testid="billing-account-contact-address2">
      {{ contact.address2 }}
    </div>
    <div data-testid="billing-account-contact-city-state">
      {{ contact.city }} {{ contact.state }}
    </div>
    <div data-testid="billing-account-contact-postal-code">{{ contact.postalCode }}</div>
    <div data-testid="billing-account-contact-country">{{ contact.country }}</div>
  </div>
</template>
